import React, { PropsWithChildren } from "react";
import { useEditor } from "@craftjs/core";

export const PreviewPanel: React.FC<PropsWithChildren> = ({ children }) => {
  const { connectors } = useEditor();

  return (
    <div
      ref={(ref: any) => connectors.select(connectors.hover(ref, ""), "")}
      className="main-canvas"
    >
      {children}
    </div>
  );
};
